import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { TaskType_Entity } from "../../entities/taskType";
import { filmsApi } from "../api/filmsApi";

const taskTypesAdapter = createEntityAdapter<TaskType_Entity>();
const initialState = taskTypesAdapter.getInitialState();

export const taskTypeEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getTaskTypes: build.query<EntityState<TaskType_Entity>, void>({
      query: () => `taskTypes`,
      transformResponse: (responseData: TaskType_Entity[]) => {
        return taskTypesAdapter.setAll(initialState, responseData);
      },
      providesTags: ["taskTypes"],
    }),
    getTaskType: build.query<TaskType_Entity, number>({
      query: (id) => `taskTypes/${id}`,
      providesTags: (result, error, id) => [{ type: "taskTypes", id }],
    }),
    createTaskType: build.mutation<TaskType_Entity, Partial<TaskType_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `taskTypes`,
      }),
      invalidatesTags: ["taskTypes"],
    }),
    updateTaskType: build.mutation<
      void,
      { id: number; body: Partial<TaskType_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `taskTypes/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "taskTypes", id },
        "taskTypes",
      ],
    }),
    deleteTaskType: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `taskTypes/${id}`,
      }),
      invalidatesTags: ["taskTypes"],
    }),
  }),
});

export const {
  useGetTaskTypeQuery,
  useGetTaskTypesQuery,
  useCreateTaskTypeMutation,
  useDeleteTaskTypeMutation,
  useUpdateTaskTypeMutation,
} = taskTypeEndpoints;

export default taskTypeEndpoints;
